import { useEffect, useState } from 'react';
import { useObservedElement } from './use-observed-element';
export default function useContentHeight(headerSelector, footerSelector, disableBodyScroll) {
    var _a;
    var headerHeight = useObservedElement(headerSelector);
    var footerHeight = useObservedElement(footerSelector);
    var _b = useState(0), headerFooterHeight = _b[0], setHeaderFooterHeight = _b[1];
    useEffect(function () {
        var id = requestAnimationFrame(function () { return setHeaderFooterHeight(headerHeight + footerHeight); });
        return function () { return cancelAnimationFrame(id); };
    }, [headerHeight, footerHeight]);
    var heightStyleValue = "calc(100vh - " + headerFooterHeight + "px)";
    return {
        headerHeight: headerHeight,
        footerHeight: footerHeight,
        contentHeightStyle: (_a = {},
            _a[disableBodyScroll ? 'height' : 'minHeight'] = heightStyleValue,
            _a),
        panelHeightStyle: {
            height: heightStyleValue
        }
    };
}
